import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/auth.hook';

interface AuthWrapperProps {
    children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
    const { checkAuthStatus, isLoading } = useAuth();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        // Fallback timeout: nếu server down và checkAuthStatus bị treo,
        // sau 5 giây vẫn unblock UI để hiển thị app / redirect login
        const timeout = setTimeout(() => setIsInitialized(true), 5000);

        const initializeAuth = async () => {
            try {
                await checkAuthStatus();
            } catch (error) {
                console.error('Auth initialization error:', error);
            } finally {
                clearTimeout(timeout);
                setIsInitialized(true);
            }
        };

        initializeAuth();
    }, []); // Empty dependency để chỉ chạy 1 lần khi mount

    // Hiển thị loading chỉ khi đang loading và chưa initialized
    if (!isInitialized && isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
            </div>
        );
    }

    // Render children ngay cả khi token hết hạn
    // Auth middleware sẽ handle redirect nếu cần
    return <>{children}</>;
}
